import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { MatSpinner } from '@angular/material/progress-spinner';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SpinnerComponent } from '../components/spinner/spinner.component';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private spinnerRef: OverlayRef = this.cdkSpinnerCreate();

  loaderValue$ = new BehaviorSubject<number>(0);
  loaderValue = this.loaderValue$.asObservable();


  constructor(
    private overLay: Overlay
  ) { }

  private cdkSpinnerCreate() {
    return this.overLay.create({
      hasBackdrop: true,
      backdropClass: 'dark-backdrop',
      positionStrategy: this.overLay.position()
        .global()
        .centerHorizontally()
        .centerVertically()
    })
  }

  showSpinner() {
    console.log('showSpinner')
    this.spinnerRef.attach(new ComponentPortal(MatSpinner))
  }

  stopSpinner() {
    if (this.spinnerRef.hasAttached()) this.spinnerRef.detach();
  }

  showLoader() {
    this.spinnerRef.attach(new ComponentPortal(SpinnerComponent))
  }

  updateLoader(value: number) {
    this.loaderValue$.next(value)
  }

  stopLoader() {
    this.loaderValue$.next(0);
    if (this.spinnerRef.hasAttached()) this.spinnerRef.detach();
  }
}
